import { useEffect } from 'react'

/**
 * Which project the shell is showing, readable from outside any component.
 *
 * A write that answers late is answered to whatever screen happens to be up by
 * then, and that may be another project's. The session era already says
 * whether the person who asked is still the one at this browser; this says
 * whether they are still on the project they asked from. Something that would
 * follow on its own -- opening a change that has just been raised -- belongs
 * to the project it was raised in, and is not sent while the person is
 * looking at another one.
 *
 * Kept as the projects mounted in order, the last being the one shown, rather
 * than as one value: a project's screen unmounting after the next one mounted
 * must not clear the newer one.
 */
const shown: string[] = []

/** The project on screen now, if any. */
export function activeProject(): string | undefined {
  return shown[shown.length - 1]
}

/** Mark a project as the one on screen for as long as the caller is mounted. */
export function useActiveProject(projectId: string): void {
  useEffect(() => {
    shown.push(projectId)
    return () => {
      const at = shown.lastIndexOf(projectId)
      if (at >= 0) shown.splice(at, 1)
    }
  }, [projectId])
}
